// Import and register Stimulus controllers (for esbuild bundle; importmap uses stimulus-loading)
import { application } from "./application"
import HelloController from "./hello_controller"
import TabsController from "./tabs_controller"
import NestedLinksController from "./nested_links_controller"
import DialogController from "./ruby_ui/dialog_controller"
import SortBlocksController from "./sort_blocks_controller"
import SortableController from "./sortable_controller"
import FamilyMemberFormController from "./family_member_form_controller"
import AccordionController from "./accordion_controller"

application.register("hello", HelloController)
application.register("tabs", TabsController)
application.register("nested-links", NestedLinksController)
application.register("ruby-ui--dialog", DialogController)
application.register("sort-blocks", SortBlocksController)
application.register("sortable", SortableController)
application.register("family-member-form", FamilyMemberFormController)
application.register("accordion", AccordionController)
